import { render } from "./Sites.vue?vue&type=template&id=044fa5c8"
import script from "./Sites.vue?vue&type=script&lang=js"
export * from "./Sites.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__